/**
 * Design System 2.0 Grid & Spacing
 * Grid
 * https://www.figma.com/design/hf7KKkXF5PmGtGSMYRGRCv/DDS-2.0?node-id=8-6806&t=CKgl4zP6zLt6IvKK-0
 * Spacing
 * https://www.figma.com/design/hf7KKkXF5PmGtGSMYRGRCv/DDS-2.0?node-id=23-15347&t=CKgl4zP6zLt6IvKK-0
 */
export const spacing = {
    none: 0,
    xxsmall: 2,
    xsmall: 4,
    small: 8,
    medium: 12,
    large: 16,
    xlarge: 24,
    xxlarge: 32,
    xxxlarge: 40,
    big: 48,
    xbig: 56,
    xxbig: 64,
    xxxbig: 72,
    huge: 80,
    xhuge: 96
};
export const grids = {
    mobile: {
        minWidth: 375,
        maxWidth: 599,
        columns: 4,
        margin: 16,
        gutter: 16
    },
    tablet: {
        minWidth: 600,
        maxWidth: 768,
        columns: 8,
        margin: 24,
        gutter: 24
    },
    desktopSmall: {
        minWidth: 769,
        maxWidth: 1024,
        columns: 12,
        margin: 48,
        gutter: 24
    },
    desktopHD: {
        minWidth: 1025,
        maxWidth: 1440,
        columns: 12,
        margin: 96,
        gutter: 24
    }
    /*
     * Design incomplete
     * desktopQHD: {
     *   minWidth: 1440,
     *   maxWidth: null,
     *   columns: 12,
     *   margin: 96,
     *   gutter: 24
     * }
     */
};
